import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let trackingLoaded = false;
let trackingConfig = null;

export function useTracking() {
  const [config, setConfig] = useState(trackingConfig);

  useEffect(() => {
    if (trackingLoaded) return;
    trackingLoaded = true;
    fetch(`${API}/config/tracking`)
      .then((r) => r.json())
      .then((data) => {
        trackingConfig = data;
        setConfig(data);
        injectScripts(data);
      })
      .catch(() => {});
  }, []);

  return config;
}

function injectScripts(cfg) {
  // Google Tag Manager
  if (cfg.gtm_id && cfg.gtm_id !== "" && !cfg.gtm_id.includes("PLACEHOLDER")) {
    const s = document.createElement("script");
    s.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${cfg.gtm_id}');`;
    document.head.appendChild(s);
    // noscript
    const ns = document.createElement("noscript");
    ns.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${cfg.gtm_id}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    document.body.prepend(ns);
  }

  // GA4
  if (cfg.ga4_measurement_id && cfg.ga4_measurement_id !== "" && !cfg.ga4_measurement_id.includes("PLACEHOLDER")) {
    const gs = document.createElement("script");
    gs.async = true;
    gs.src = `https://www.googletagmanager.com/gtag/js?id=${cfg.ga4_measurement_id}`;
    document.head.appendChild(gs);
    const gi = document.createElement("script");
    gi.innerHTML = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${cfg.ga4_measurement_id}');`;
    document.head.appendChild(gi);
  }

  // Facebook Pixel
  if (cfg.facebook_pixel_id && cfg.facebook_pixel_id !== "" && !cfg.facebook_pixel_id.includes("PLACEHOLDER")) {
    const fp = document.createElement("script");
    fp.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${cfg.facebook_pixel_id}');fbq('track','PageView');`;
    document.head.appendChild(fp);
  }
}

// Event helpers
export function trackEvent(eventName, data = {}) {
  // GTM / GA4 dataLayer
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: eventName, ...data });

  // Facebook Pixel
  if (window.fbq) {
    const fbMap = {
      search_flights: "Search",
      begin_checkout: "InitiateCheckout",
      add_payment_info: "AddPaymentInfo",
      purchase: "Purchase",
    };
    const fbEvent = fbMap[eventName];
    if (fbEvent) {
      window.fbq("track", fbEvent, data);
    }
  }
}

export default function TrackingScripts() {
  useTracking();
  return null;
}
